export const shareModuleType = {
  DOCUMENT_REPO: "DOCUMENT_REPO",
  CONTACT_REPO: "CONTACT_REPO",
  CALENDAR: "CALENDAR",
  MY_VOICE_NOTE: "MY_VOICE_NOTE",
  EVENT: "EVENT",
  MOM: "MOM",
};
